import React, { createContext, useContext } from "react";
import useUserRoleLocalStorage from "../UseUserRoleLocalStorage/UseUserRoleLocalStorage";

const AuthContext = createContext({
    userRole: null,
    roleLoading: true,
});

export const AuthProvider = ({ children }) => {
    const value = useUserRoleLocalStorage();
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
